import { IconProps } from "../../../types/style";

const PlusCircleSvg = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 1C3.745 1 1.5 3.245 1.5 6C1.5 8.755 3.745 11 6.5 11C9.255 11 11.5 8.755 11.5 6C11.5 3.245 9.255 1 6.5 1ZM8.5 6.375H6.875V8C6.875 8.205 6.705 8.375 6.5 8.375C6.295 8.375 6.125 8.205 6.125 8V6.375H4.5C4.295 6.375 4.125 6.205 4.125 6C4.125 5.795 4.295 5.625 4.5 5.625H6.125V4C6.125 3.795 6.295 3.625 6.5 3.625C6.705 3.625 6.875 3.795 6.875 4V5.625H8.5C8.705 5.625 8.875 5.795 8.875 6C8.875 6.205 8.705 6.375 8.5 6.375Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default PlusCircleSvg;
